export var B2BModeEnabledState;
(function (B2BModeEnabledState) {
    B2BModeEnabledState["B2C_CUSTOMER"] = "B2C_CUSTOMER";
    B2BModeEnabledState["B2B_CUSTOMER_B2C_MODE"] = "B2B_CUSTOMER_B2C_MODE";
    B2BModeEnabledState["B2B_CUSTOMER_B2B_MODE"] = "B2B_CUSTOMER_B2B_MODE";
})(B2BModeEnabledState || (B2BModeEnabledState = {}));
